<div class="m-4">
  <mat-card class="p-4">
    <h3>Onboarding Super Smart</h3>
    <p class="text-muted">
      Siga os passos para inserir os dados necessários para utilizar o
      <strong class="text-hub-primary">{{ appName }}</strong>
    </p>
    <mat-stepper #stepper labelPosition="bottom">
      <mat-step label="Quem é Você?">
        <ng-template matStepContent>
          <div class="row flex-column align-items-center">
            <div class="col-md-6 d-flex flex-column">
              <mat-form-field>
                <mat-label>Cartão do CNPJ</mat-label>
                <input
                  matInput
                  type="text"
                  mask="000.000/0000-00"
                  (blur)="loadCnpj()"
                  [formControl]="cnpjCtrl"
                />
                <mat-icon matSuffix style="color: green" *ngIf="showCorrect1">
                  done
                </mat-icon>
                <mat-error>Este campo é obrigatório</mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Apólice de Seguro SulAmerica Saúde</mat-label>
                <input matInput type="text" [formControl]="apoliceCtrl" />
                <mat-icon matSuffix style="color: green" *ngIf="showCorrect2">
                  done
                </mat-icon>
                <mat-error>Este campo é obrigatório</mat-error>
              </mat-form-field>

              <button mat-raised-button color="primary" matStepperNext>
                BUSCAR
              </button>
            </div>
          </div>
        </ng-template>
      </mat-step>
      <mat-step label="Dados da Empresa">
        <ng-template matStepContent>
          <div class="row">
            <div class="col-12">
              <h5 class="mb-3">1. Dados da Empresa</h5>
            </div>
            <mat-form-field class="col-lg-4 col-md-6">
              <mat-label>Razão Social</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <mat-form-field class="col-lg-4 col-md-6">
              <mat-label>Grupo Econômico</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <mat-form-field class="col-lg-4 col-md-6">
              <mat-label>CNPJ</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <mat-form-field class="col-lg-4 col-md-6">
              <mat-label>Endereço</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <mat-form-field class="col-lg-4 col-md-6">
              <mat-label>CEP</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <mat-form-field class="col-lg-4 col-md-6">
              <mat-label>Bairro</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <mat-form-field class="col-lg-4 col-md-6">
              <mat-label>Estado</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <mat-form-field class="col-lg-4 col-md-6">
              <mat-label>Cidade</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <mat-form-field class="col-lg-4 col-md-6">
              <mat-label>Telefone</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <mat-form-field class="col-lg-4 col-md-6">
              <mat-label>E-mail</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <mat-form-field class="col-lg-4 col-md-6">
              <mat-label>Ramo de Atividade</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <div class="col-12">
              <h5 class="mb-3">2. Dados da Apólice</h5>
            </div>

            <mat-form-field class="col-xl-3 col-lg-4 col-md-6">
              <mat-label>Seguradora</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <mat-form-field class="col-xl-3 col-lg-4 col-md-6">
              <mat-label>Apólice</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <mat-form-field class="col-xl-3 col-lg-4 col-md-6">
              <mat-label>Contrato</mat-label>
              <input type="text" matInput />
            </mat-form-field>

            <mat-form-field class="col-xl-3 col-lg-4 col-md-6">
              <mat-label>CNPJ</mat-label>
              <input type="text" matInput />
            </mat-form-field>
          </div>

          <div class="d-flex justify-content-between mt-3">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              matStepperPrevious
            >
              <div class="d-flex align-items-center">Voltar</div>
            </button>
            <button
              mat-raised-button
              color="primary"
              type="submit"
              matStepperNext
            >
              <div class="d-flex align-items-center">Continuar</div>
            </button>
          </div>
        </ng-template>
      </mat-step>
      <mat-step label="Importação das Vidas">
        <ng-template matStepContent>
          <table
            mat-table
            [dataSource]="dataSource"
            class="w-100"
            *ngIf="temArquivo"
          >
            <ng-container matColumnDef="nomeBeneficiario">
              <th mat-header-cell *matHeaderCellDef>Nome</th>
              <td mat-cell *matCellDef="let row">
                {{ row?.nomeBeneficiario }}
              </td>
            </ng-container>

            <ng-container matColumnDef="tipoBeneficiario">
              <th mat-header-cell *matHeaderCellDef>Tipo</th>
              <td mat-cell *matCellDef="let row">
                <span
                  class="badge"
                  [class.bg-primary]="row.tipoBeneficiario === 0"
                  [class.bg-info]="row.tipoBeneficiario !== 0"
                >
                  {{ row?.tipoBeneficiario | tipoBeneficiario }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="apelidoProvedorGeral">
              <th mat-header-cell *matHeaderCellDef>{{ 'provedor' | label }}</th>
              <td mat-cell *matCellDef="let row">
                {{ row?.apelidoProvedorGeral }}
              </td>
            </ng-container>

            <ng-container matColumnDef="descricaoProduto">
              <th mat-header-cell *matHeaderCellDef>Descrição</th>
              <td mat-cell *matCellDef="let row">
                {{ row?.descricaoProduto }}
              </td>
            </ng-container>

            <ng-container matColumnDef="statusProdutoBeneficiario">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let row">
                <span class="badge bg-warning">
                  Aguardando Comunicação com {{ 'provedor' | label }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="tipoMovimentacao">
              <th mat-header-cell *matHeaderCellDef>Tipos</th>
              <td mat-cell *matCellDef="let row">Inclusão</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <div
            class="d-flex justify-content-{{
              temArquivo ? 'end' : 'center'
            }} mt-3"
          >
            <button mat-raised-button color="primary" (click)="onUploadClick()">
              <mat-icon>upload</mat-icon>
              Importar Movimentação
            </button>
          </div>
        </ng-template>
      </mat-step>
    </mat-stepper>
  </mat-card>
</div>
